import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useTabbar } from '@common/providers/useTabbar';
import { Page } from '@common/ui/Page';
import { markInviteRouteVisited } from '@common/utils/startParam';

import { InviteIntro } from '@widgets/invite/InviteIntro';

export const Route = createFileRoute('/invite/')({
  component: Component,
});

export default function Component() {
  const { setShowNavigation } = useTabbar();

  useEffect(() => {
    setShowNavigation(false);
    markInviteRouteVisited();
  }, [setShowNavigation]);

  return (
    <Page hasBackground>
      <InviteIntro />
    </Page>
  );
}
